import React from 'react';
import WorkOrderTable from '../WorkOrderTable';
import { BUYER_WO_FILTERS_ORDER } from '../../utils/WorkOrderUtils';

export default function WorkOrdersAllIndexPage() {
	return (
		<WorkOrderTable
			handleQueryParams
			filterConfig={{
				filters: BUYER_WO_FILTERS_ORDER,
			}}
			preAppliedFilters={{}}
			targetCollectionName="allWorkOrdersIndex"
		/>
	);
}
